import { useContext, useEffect, useState } from "react";
import {
  Button,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  Navbar,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/logo.jpeg";
// import FormSelect from "../../../components/FormSelect";
// import { getCompanies } from "../../../services/company.service";
// import { CompanyContext } from "../../../contexts/CompanyContext";
import { AuthContext } from "../../../contexts/AuthContext";
import { CompanyContext } from "../../../contexts/CompanyContext";

export default function Header() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [companies, setCompanies] = useState([]);
  const { selectedCompany } = useContext(CompanyContext);
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  // const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    const sidebarElement = document.querySelector(".sidebarMenu");
    const initialState =
      sidebarElement?.classList.contains("sidebarAction") ||
      document.body.classList.contains("sidebarAction");
    setIsActive(Boolean(initialState));
  }, []);

  //  const [profile, setProfile] = useContext(ProfileContext);
  const handleClick = () => {
    const nextState = !isActive;
    setIsActive(nextState);
    document.body.classList.toggle("sidebarAction", nextState);
    const sidebarElement = document.querySelector(".sidebarMenu");
    sidebarElement?.classList.toggle("sidebarAction", nextState);
  };

  // const [userDetails] = useContext(ProfileContext);

  return (
    <Navbar
      bg='white'
      variant='light'
      className='px-md-2 bg-white'
      style={{
        zIndex: 1,
        borderBottom: "1px solid #e5e7eb",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        minHeight: "64px",
        height: "65px",
      }}
    >
      <Container fluid className='px-3 px-xl-4 mh-54 d-flex align-items-center w-100'>
        <Button
          color='white'
          role='button'
          tabIndex={0}
          onClick={handleClick}
          className='navMenuBtn border-0 p-0 d-inline-flex align-items-center justify-content-center'
          style={{
            width: 32,
            height: 32,
            minWidth: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 6,
            background: "#f3f4f6",
            lineHeight: 0,
            flexShrink: 0,
          }}
        >
          <span
            className={
              isActive ? "menuTrigger position-relative active" : "menuTrigger position-relative"
            }
          ></span>
        </Button>

        <Link to='/' className='headerLogoLink d-lg-none mx-2 mx-md-3 px-1'>
          <img src={Logo} alt='Logo' className='img-fluid headerLogoImg' width={75} height={46} />
        </Link>

        {/* <div
          className='ms-3'
          style={{ width: "300px", zIndex: 1, position: "relative", marginTop: "9px" }}
        >
          <FormSelect
            id='company'
            name='company'
            formGroupClasses='m-0'
            options={companies}
            onChange={(name, value) => {
              handleChangeCompany(value);
              // setFieldValue(name, value);
            }}
            value={selectedCompany}
          />
        </div> */}

        <Nav className='ms-auto align-items-center'>
          {/* <div
            className='documentLink me-md-2 me-1'
            // onClick={() => {
            //   window.open("https://techdocs.pfplogistics.com", "_blank");
            // }}
          >
            <div className='documentLinkIcon fs-15 fw-bold text-decoration-none p-0 position-relative w-40 h-40 rounded-circle d-inline-flex align-items-center justify-content-center'>
              document
            </div>
          </div> */}

          {/* <Dropdown
       
            className='notificationDropdown me-md-2 me-1'
          >
            <DropdownToggle
              variant='link'
              // id='dropdown-notification'
              className='fs-15 fw-bold text-decoration-none p-0 position-relative w-40 h-40 rounded-circle d-inline-flex align-items-center justify-content-center'
            >
              bell
              <span className='position-absolute top-0 end-0 rounded-circle bg-danger p-1 notifiyDot'>
                <span className='visually-hidden'>unread messages</span>
              </span>
            </DropdownToggle>{" "}
            <DropdownMenu align='end'>
              <DropdownItem>Coming soon...</DropdownItem>
            </DropdownMenu>
          </Dropdown> */}
          {/* <div className='vr mx-2 mx-md-4'></div> */}
          <Dropdown isOpen={dropdownOpen} toggle={toggle} className='profileDropdown ms-md-2 ms-1'>
            <DropdownToggle
              color='white'
              variant='link'
              id='dropdown-profile'
              className='border-0 fw-bold text-decoration-none p-0 text-start d-flex align-items-center gap-2'
              style={{ fontSize: "0.8rem" }}
            >
              <img
                alt='Profile'
                className='object-fit-cover rounded-circle'
                src='https://fastly.picsum.photos/id/953/200/200.jpg?hmac=S5zbAl9YqUc02Oezl6cR8gcLfF3pwkQ5_AcG8JXjeC0'
                width={34}
                height={34}
                style={{ border: "2px solid #e5e7eb" }}
              />
              <div
                className='align-middle d-none d-md-inline-block text-truncate mw-150'
                style={{ lineHeight: 1.3 }}
              >
                <div style={{ fontSize: "0.78rem", fontWeight: 600, color: "#1f2937" }}>
                  Super Admin
                </div>
                <small style={{ fontSize: "0.7rem", color: "#6b7280", fontWeight: 500 }}>
                  {selectedCompany.name}
                </small>
              </div>
            </DropdownToggle>

            <DropdownMenu align='end'>
              <DropdownItem
                onClick={() => {
                  navigate("/profile");
                }}
              >
                Profile
              </DropdownItem>
              <DropdownItem onClick={logout}>Logout</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Nav>
      </Container>
    </Navbar>
  );
}
